import { render, staticRenderFns } from "./AutoProposalBtn.vue?vue&type=template&id=6bb50d23&"
import script from "./AutoProposalBtn.vue?vue&type=script&lang=js&"
export * from "./AutoProposalBtn.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports